<div class="sds-public-preview-page">
  <div class="sds-public-preview-shell">
    <img src="assets/images/KubaLogo.png" alt="Kuba logo" class="sds-public-preview-logo" />
    <button
      class="btn btn-primary sds-public-preview-open-btn"
      type="button"
      (click)="openPdfPreview()"
      [disabled]="!pdfPreviewUrl"
    >
      <i class="pi pi-file-pdf"></i>
      <span [translate]="'SDS_PREVIEW_PDF'"></span>
    </button>
  </div>
</div>

<p-dialog
  [header]="'SDS_PDF_PREVIEW_TITLE' | translate"
  [(visible)]="pdfPreviewVisible"
  [style]="{ width: '100vw', height: '100vh', maxWidth: '100vw' }"
  [baseZIndex]="10000"
  [maximizable]="true"
  [resizable]="false"
  [draggable]="false"
  [modal]="true"
  (onHide)="closePdfPreview()"
  styleClass="sds-public-pdf-dialog"
>
  <div class="sds-public-pdf-toolbar">
    <div class="sds-public-pdf-hint">
      <i class="pi pi-info-circle"></i>
      <span [translate]="'SDS_PDF_PREVIEW_TITLE'"></span>
    </div>
    <div class="sds-public-pdf-actions">
      <button
        class="btn btn-outline-primary sds-public-pdf-download-btn"
        type="button"
        (click)="downloadPdf()"
        [disabled]="!downloadUrl"
        [pTooltip]="'SDS_DOWNLOAD_PDF' | translate"
        tooltipPosition="left"
      >
        <i class="pi pi-download"></i>
        <span [translate]="'SDS_DOWNLOAD_PDF'"></span>
      </button>
    </div>
  </div>

  <div class="sds-public-pdf-iframe-wrapper" *ngIf="pdfPreviewUrl">
    <iframe
      [src]="pdfPreviewUrl"
      class="sds-public-pdf-iframe"
      frameborder="0"
    ></iframe>
  </div>
  <div class="sds-public-pdf-no-file" *ngIf="!pdfPreviewUrl">
    <i class="pi pi-exclamation-triangle"></i>
    <span [translate]="'SDS_PDF_NOT_AVAILABLE'"></span>
  </div>
</p-dialog>
